import { Component, Input, OnDestroy } from '@angular/core';
import { ChatChannel } from '@app/model/chat-channel-v2';
import { AppSyncChatMessage, ChatService } from '@app/services/chat.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-chat-channel-v2',
  templateUrl: './chat-channel-v2.component.html',
  styleUrls: ['./chat-channel-v2.component.scss'],
  standalone: false
})
export class ChatChannelV2Component implements OnDestroy {
  @Input() public disabled = false;
  @Input() public set channelUrl(value: string) {
    if (!value) {
      return;
    }

    this.groupChannel = { url: value };
  }

  @Input() public hideBorder = true;
  @Input() public groupChannel: ChatChannel | undefined;

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(private readonly chatService: ChatService) { }

  public markAsRead(): void {
    // no-op: read receipts not supported by ChatService
  }

  public editMessage(_item: AppSyncChatMessage): void {
    // no-op: message editing not supported by ChatService
  }

  public updateMessage(_context: { message: string; reference: AppSyncChatMessage }): void {
    // no-op: message editing not supported by ChatService
  }

  public sendMessage(message: string): void {
    if (!this.groupChannel?.url) {
      return;
    }

    this.chatService.sendMessage({ channelUrl: this.groupChannel.url, content: message })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
